
<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    deleteTitle="Deleção de Cultura"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar esta cultura?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@components/shared/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
  },
  methods: {
    destroyEntry: function() {
      this.$set(this.entry, "_destroy", true);
      this.$emit("entry-destroyed", this.entry);
      this.$refs.baseDelete.closeDialog();
    },
  }
}
</script>

<style scoped></style>

